import React from 'react';
import PageHelmet from '../../components/shared/PageHelmet';
import Preloader from '../../components/shared/Preloader';
import NavHeader from '../../components/NavHeader/NavHeader';
import HomeHeroSlider from './HomeHeroSlider/HomeHeroSlider';
import HomeOurStory from './HomeOurStory/HomeOurStory';
import MetricsShowcase from './MetricsShowcase/MetricsShowcase';
import OurApproach from './OurApproach/OurApproach';
import HomeBlogs from './HomeBlogs/HomeBlogs';
import MainFooter from '../../components/MainFooter/MainFooter';
import LetsConnect from '../../components/LetsConnect/LetsConnect';
import HomeOfferings from './HomeOfferings/HomeOfferings';
import IndustriesShowcase from './IndustriesShowcase/IndustriesShowcase';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import WhyChoose from './WhyChoose/WhyChoose';
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

const OurApproachData = [
   {
      id: 1,
      title: <h3><Link to="/">Discover</Link></h3>,
      img: "assets/img/project/discover_icon_white.svg",
      content: "Delving into the depths of your vision and understanding end-user perceptions"
   },
   {
      id: 2,
      title: <h3><Link to="/">Define</Link></h3>,
      img: "assets/img/project/define_icon_white.svg",
      content: "Blueprinting the scope of work involved and the roadmap to accomplishment"
   },
   {
      id: 3,
      title: <h3><Link to="/">Design</Link></h3>,
      img: "assets/img/project/design_icon_white.svg",
      content: "Creating user journeys, interactions, testing ideas through mockups & wireframes"
   },
   {
      id: 4,
      title: <h3><Link to="/">Develop</Link></h3>,
      img: "assets/img/project/develop_icon_white.svg",
      content: "Breathing life into wireframes & sculpting functionality within interactions through technology"
   },
   {
      id: 5,
      title: <h3><Link to="/">Deliver</Link></h3>,
      img: "assets/img/project/deliver_icon_white.svg",
      content: "Iterating, reiterating, validating and finalizing the polished outcome ready to hit the market"
   }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const Home = () => {
   return (
      <>
         <div>
            <Preloader />
            <PageHelmet
               pageTitle="Software Development Company | Web & Mobile App Development"
               description="Harsoft Solutions is a software development company and web development company delivering mobile app development, React Native development, Python development, AI development services, and SaaS development."
               keywords="Software Development Company, Web Development Company, Mobile App Development, AI Development Services, React Native Development, Python Development, SaaS Development"
               path="/"
            />
            <NavHeader />
            <main>
               <HomeHeroSlider />
               <WhyChoose />
               <HomeOurStory />
               <MetricsShowcase />
               <HomeOfferings />
               <IndustriesShowcase />
               <OurApproach OurApproachData={OurApproachData} bgColors={bgColors} title="Our Approach" />
               <HomeBlogs />
               <LetsConnect />
            </main>
            <MainFooter />
         </div>
      </>
   );
};

export default Home;
